import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './ckeditor-styles.css';
import App from '@app/App';
import { setVhProperty } from '@app/hooks/useVh';
import { NavProvider } from '@app/contexts/NavContext';

setVhProperty();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <NavProvider>
      <App />
    </NavProvider>
  </React.StrictMode>
);
